"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchQueryToSaveSearchSet = void 0;
var AggregatedMapDataType_1 = require("@/pages/search/states/AggregatedMapDataType");
exports.searchQueryToSaveSearchSet = function (searchQuery, name) {
    var saveSearchSet = {
        name: name,
        currencyId: searchQuery.currencyId,
        languageId: searchQuery.languageId,
        listingTypeId: searchQuery.listingTypeId,
        layout: searchQuery.layout,
        area: searchQuery.area,
        district: searchQuery.district,
        keyword: searchQuery.keyword,
        priceMin: searchQuery.priceMin,
        priceMax: searchQuery.priceMax,
        sizeType: searchQuery.sizeType,
        sizeMin: searchQuery.sizeMin,
        sizeMax: searchQuery.sizeMax,
        bedroomMin: searchQuery.bedroomMin,
        bedroomMax: searchQuery.bedroomMax,
        orderBy: searchQuery.orderBy,
        sortBy: searchQuery.sortBy,
        searchSaveSetType: searchQuery.searchSaveSetType,
        isCustomName: true,
        searchResultId: searchQuery.searchResultId,
        searchResultType: searchQuery.searchResultType,
    };
    if (searchQuery.hasBalcony)
        saveSearchSet.hasBalcony = true;
    if (searchQuery.hasGarden)
        saveSearchSet.hasGarden = true;
    if (searchQuery.hasMaidRoom)
        saveSearchSet.hasMaidRoom = true;
    if (searchQuery.hasOutdoorSpace)
        saveSearchSet.hasOutdoorSpace = true;
    if (searchQuery.hasParking)
        saveSearchSet.hasParking = true;
    if (searchQuery.hasTerrace)
        saveSearchSet.hasTerrace = true;
    saveSearchSet.isMap = searchQuery.isMap;
    saveSearchSet.geoString = searchQuery.geoString || '';
    saveSearchSet.zoomLevel = searchQuery.zoomLevel || 0;
    saveSearchSet.mapDetailsType = searchQuery.mapDetailsType || AggregatedMapDataType_1.AggregatedMapDataType.Area;
    return saveSearchSet;
};
